import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { type CanMatchFn } from '@angular/router';

import { filter, first, map } from 'rxjs/operators';

import { ConfigService } from '../services/config/config.service';
import { LoggerService } from '../services/logger/logger.service';

const LOG_OPTIONS = { when: ['debugGuards'] as const };

export const configLoadedGuard: CanMatchFn = () => {
  const configService = inject(ConfigService);
  const logger = inject(LoggerService);

  logger.log('[ConfigLoadedGuard] Checking config status', LOG_OPTIONS);

  return toObservable(configService.isConfigLoaded).pipe(
    filter(Boolean),
    first(),
    map(() => {
      logger.log('[ConfigLoadedGuard] Config loaded', LOG_OPTIONS);
      return true;
    })
  );
};
